import { InjectableClass } from "@fino/lib-injection";

export class PlausibleService extends InjectableClass {
	get tenant() {
		return this.envService.getTenant();
	}

	constructor($window, envService) {
		"ngInject";
		super({ $window, envService });
	}

	trackPageview() {
		if (!this.$window.plausible) return;
		this.$window.plausible("pageview");
	}

	trackEvent(eventName, properties) {
		if (!this.$window.plausible) return;
		this.$window.plausible(eventName, {
			props: {
				tenant: this.tenant,
				...properties,
			},
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/common/tracking/plausible/plausible.service.js